import { SvgIconProps } from './icon-props';

export default function Info({ height = 20, width = 20, fill = '#231f20' }: SvgIconProps) {
	return (
		<svg
			width={width}
			height={height}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 20"
			fill="none"
		>
			<path fill={fill} fillRule="evenodd" d="M20 9h-9V0H9v9H0v2h9v9h2v-9h9V9z" />
		</svg>
	);
}
